module.exports = __webpack_public_path__ + "static/media/jwtHeaderPayload.d68424c9.png";